/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * Legacy index: deep links a BranchSettings redirigen a Identidad (hub real).
 */
import React, { useEffect } from 'react';
import { View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { ShellScreenLoading } from '../../shared/layout/ShellScreenLoading';

export const BranchSettingsScreen = () => {
  const navigation = useNavigation<any>();

  useEffect(() => {
    navigation.replace('BranchIdentity');
  }, [navigation]);

  return (
    <View>
      <ShellScreenLoading label="Cargando…" />
    </View>
  );
};
